import React, { ChangeEvent } from 'react';
import { Box, InputBase } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface SearchBarProps {
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  width?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search…',
  onChange,
  width = '40%',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ccc',
        borderRadius: 2,
        paddingX: 1.5,
        paddingY: 0.5,
        width: { xs: '100%', sm: width }, // Full width on mobile, adjustable on larger screens
      }}
    >
      <SearchIcon sx={{ color: 'gray', marginRight: 1 }} />
      <InputBase
        placeholder={placeholder}
        sx={{ flex: 1, fontSize: '0.9rem' }} // Always take full space inside Box
        inputProps={{ 'aria-label': 'Search' }}
        onChange={onChange}
      />
    </Box>
  );
};

export default SearchBar;
